import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useSubmittalTrackerContext } from '../../../../SubmittalTrackerContext'
import { Submittal } from '../../../../SubmittalTrackerContext/types'
import { useRestoreCaSubmittalMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRestoreNotification } from 'hooks/notificationHandler'

export function useRestoreOptions(): RestoreRowActionOptions<Submittal> {
  const { refetch } = useSubmittalTrackerContext()
  const [restore] = useRestoreCaSubmittalMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreConstructionAdminSubmittal: {
        submittal: { sharePointFolderName },
      },
    }) => simpleRestoreNotification(sharePointFolderName),
  })
  return {
    permission: Permission.RemoveRestoreConstructionAdminSubmittal,
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
